<template>
    <div style="width: 100%; height: 100vh;">
        <router-view></router-view>
    </div>
</template>
